import React from "react";
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import Divider from "@material-ui/core/Divider";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import Avatar from "@material-ui/core/Avatar";
import Typography from "@material-ui/core/Typography";
import Badge from '@material-ui/core/Badge';


const styles = theme => ({
    userList_List: {
    },
    inline: {
        display: "inline"
    },
    purple: {
        color: "white",
        backgroundColor: "indianred",
        width: '25px',
        height: '25px',
        marginLeft: '6px',
        fontSize: '16px'
    },
    avatar: {
        minWidth: '30px',
        marginTop: '4px',
    },
    //通常のユーザリストの色
    list_item: {
        padding: "1px 10px 1px 10px",
        backgroundColor: "white",
        '&:hover': {
            backgroundColor: "#E5E5E5",
        },
        display: "flex",
        margin: "0 auto",
    },
    //未対応のユーザリストの色
    list_item_notSupport: {
        padding: "1px 10px 1px 10px",
        backgroundColor: "#FFEBCD",
        '&:hover': {
            backgroundColor: "#FDF4E5",
        },
        display: "flex",
        margin: "0 auto",
    },
    list_item_common: {
        flexWrap: "wrap"
    },
    list_item_avatar: {
        display: "block",
        wordWrap: "break-word",
        width: "100%",
        maxWidth: "120px"
    },
    user_name: {
        flexWrap: "wrap"
    },
    list_item_counselingKubun: {
        //top: "13px",
        position: "relative",
        maxWidth: "150px",
        width: "100%",
        marginleft: '200px',
        marginRight: '20px'
    },
    list_item_counseling_a: {
        textAlign:'left',
        maxWidth: "340px",
        width: "30%",
        position: "relative"
    },
    list_item_counseling_b: {
        textAlign:'left',
        maxWidth: "220px",
        width: "30%",
        position: "relative"
    },
    list_item_counseling_c: {
        marginLeft: "auto",
        marginRight: "5px",
    },
    userList_content_font: {
        fontSize: "12px"
    },
    userList_content_category: {
        fontSize: "12px",
        marginLeft: '20px'
    },
    userList_content_font_userName: {
        marginTop: '4px',
        fontSize: "12px"
    },
    menu: {
        width: "200px",
        maxHeight: "100px"
    },
    textField: {
        marginLeft: theme.spacing(),
        marginRight: theme.spacing(),
        width: "180px",
        top: "10px"
    },
    loading_position: {
        textAlign: "center",
        position: "fixed",
        zIndex: "2",
        top: "45%",
        right: "33%"
    },
    badge_potision: {
        top: "10px"
    },
    //未対応の状態
    supported_status: {
        padding: "0.5em 1em",
        width: "70px",
        margin: "0",
    },
    supported_status_p: {
        margin: "0",
        padding: "0",
        textAlign: "center"
    },
    //未選択の色
    supported_status_notSelect: {
        color: "#808080",
        background: "white",
        border: "solid 1px #808080"

    },
    //未対応の色
    supported_status_notSupport: {
        color: "#EB5D00",
        background: "white",
        border: "solid 1px #EB5D00",
    },
    //対応中の色
    supported_status_supporting: {
        color: "blue",
        background: "white",
        border: "solid 1px blue",
    },
    //中断の色
    supported_status_interruption: {
        color: "#EB5D00",
        background: "white",
        border: "solid 1px #EB5D00",
    },
    //返答なしの色
    supported_status_end: {
        color: "#EB5D00",
        background: "white",
        border: "solid 1px #EB5D00",
    },
    //強制終了の色
    supported_status_forcedQuit: {
        color: "red",
        background: "white",
        border: "solid 1px red",
    },
    //完了の色
    supported_status_finish: {
        color: "#4EDE80",
        background: "white",
        border: "solid 1px #4EDE80",
    }

});

const StyledBadge = withStyles((theme) => ({
    badge: {
        right: -3,
        top: 10
    },
}))(Badge);

class UserList extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
        };
        // this.isLoading = false
    }

    // コンポーネントがマウントされた直後に実行
    componentDidMount() {

    }

    // static getDerivedStateFromProps() {
    //     // this.isLoading = this.props.loadingFlag
    //     return null;
    // }

    // コンポーネントがマウントされていない時
    componentWillUnmount() {

    }

    componentDidUpdate() {

    }


    render() {
        const { classes, userListsArray, handleClick_userList, talkName} = this.props;
        return (
            <React.Fragment>
                <List>
                    {/* <div className={classes.loading_position}>
                        {this.isLoading === true ? <CircularProgress color="secondary" /> : ""}
                    </div> */}
                    {userListsArray.map((data, key) =>
                        <React.Fragment key={key}>
                            {/* 下のオンclickイベント */}
                            {/* handleClick_userList(data.counselingInfoNumber, data.userId, data.consulterFullName, data.interruptedCauseMemo) だったが、引数が増えてきたためdataを渡すように修正 */}
                            <ListItem
                                className={data.supportedStatusName !== "未対応" ? classes.list_item : classes.list_item_notSupport}
                                // alignItems="flex-start"
                                button
                                onClick={() => handleClick_userList(data)}
                                >

                                <div className={classes.list_item_common + " " + classes.list_item_avatar}>
                                    <StyledBadge
                                        color="secondary"
                                        badgeContent={data.newMessageCount}
                                        overlap="rectangular"
                                    >
                                        <ListItemAvatar className={classes.avatar}>
                                            <Avatar className={classes.purple}>
                                                {data.consulterFullName != null ? data.consulterFullName[0] : ''}
                                            </Avatar>
                                        </ListItemAvatar>
                                    </StyledBadge>
                                    {/* <div className={classes.user_name}> */}
                                    <Typography variant="body2" className={classes.userList_content_font_userName}>
                                        {data.consulterFullName != null ? data.consulterFullName : ''}
                                    </Typography>

                                    {/* </div> */}

                                </div>


                                <div className={classes.list_item_common + " " + classes.list_item_counselingKubun}>
                                    <Typography variant="body2" className={classes.userList_content_category}>
                                        {data.counselingInfoNumber != null ? data.counselingKubunName : ""}
                                    </Typography>
                                </div>
                                <div className={classes.list_item_common + " " + classes.list_item_counseling_a}>
                                    <Typography variant="body2" className={classes.userList_content_font}>
                                        {`${talkName}開始 : `}{data.counselingStartTime != null ? data.counselingStartTime : ""}
                                    </Typography>
                                    <Typography variant="body2" className={classes.userList_content_font}>
                                        {"最終受信日時 : "}{data.lastCounselingTime != null ? data.lastCounselingTime : ""}
                                    </Typography>
                                    <Typography variant="body2" className={classes.userList_content_font}>
                                        {"対応者 : "}{data.organizationDept != null ? data.organizationDept + " " : ""}{data.supporteFullName != null ? data.supporteFullName : ""}
                                    </Typography>
                                </div>
                                <div className={classes.list_item_common + " " + classes.list_item_counseling_b}>
                                    <Typography variant="body2" className={classes.userList_content_font}>
                                        {"完了日時　　 : "}{data.completeTime != null ? data.completeTime : ""}
                                    </Typography>
                                    <Typography variant="body2" className={classes.userList_content_font}>
                                        {"最終送信日時 : "}{data.lastSupportedTime != null ? data.lastSupportedTime : ""}
                                    </Typography>
                                    { data.question != null ? (
                                        <Typography variant="body2" className={classes.userList_content_font}>
                                            {"質問内容 : "}{data.question != null ? data.question : ""}
                                        </Typography>
                                    )
                                    :
                                    (
                                        <Typography variant="body2" className={classes.userList_content_font}>
                                            {"タイトル : "}{data.chatTitle != null ? data.chatTitle : ""}
                                        </Typography>
                                    )}
                                </div>
                                <div className={classes.list_item_common + " " + classes.list_item_counseling_c}>
                                    <Typography variant="body2" className={classes.userList_content_font}>
                                        {`${talkName}番号 : `}{data.counselingNumber != null ? data.counselingNumber : ""}
                                    </Typography>

                                    {/* -------------------------------------- */}
                                    {/* ここどうにかしたい */}
                                    {/* -------------------------------------- */}
                                    {/* ここのデザインを対応状況に応じて変化させる */}
                                    {data.supportedStatusName === "未選択" && (
                                        // <Typography className={classes.userList_content_font}>
                                        //     {"対応状況 : "}{data.supportedStatusName != null ? data.supportedStatusName : ""}
                                        // </Typography>
                                        <React.Fragment>
                                            <div className={classes.supported_status + " " + classes.supported_status_notSelect}>
                                                <p className={classes.supported_status_p}>{data.supportedStatusName}</p>
                                            </div>
                                        </React.Fragment>
                                    )}
                                    {/* ここのデザインを対応状況に応じて変化させる */}
                                    {data.supportedStatusName === "未対応" && (
                                        <React.Fragment>
                                            <div className={classes.supported_status + " " + classes.supported_status_notSupport}>
                                                <p className={classes.supported_status_p}>{data.supportedStatusName}</p>
                                            </div>
                                        </React.Fragment>
                                    )}
                                    {/* ここのデザインを対応状況に応じて変化させる */}
                                    {data.supportedStatusName === "対応中" && (
                                        <React.Fragment>
                                            <div className={classes.supported_status + " " + classes.supported_status_supporting}>
                                                <p className={classes.supported_status_p}>{data.supportedStatusName}</p>
                                            </div>
                                        </React.Fragment>
                                    )}
                                    {/* ここのデザインを対応状況に応じて変化させる */}
                                    {data.supportedStatusName === "中断" && (
                                        <React.Fragment>
                                            <div className={classes.supported_status + " " + classes.supported_status_interruption}>
                                                <p className={classes.supported_status_p}>{data.supportedStatusName}</p>
                                            </div>
                                        </React.Fragment>
                                    )}
                                    {data.supportedStatusName === "返答なし" && (
                                        <React.Fragment>
                                            <div className={classes.supported_status + " " + classes.supported_status_end}>
                                                <p className={classes.supported_status_p}>{data.supportedStatusName}</p>
                                            </div>
                                        </React.Fragment>
                                    )}
                                    {data.supportedStatusName === "強制終了" && (
                                        <React.Fragment>
                                            <div className={classes.supported_status + " " + classes.supported_status_forcedQuit}>
                                                <p className={classes.supported_status_p}>{data.supportedStatusName}</p>
                                            </div>
                                        </React.Fragment>
                                    )}
                                    {data.supportedStatusName === "完了" && (
                                        <React.Fragment>
                                            <div className={classes.supported_status + " " + classes.supported_status_finish}>
                                                <p className={classes.supported_status_p}>{data.supportedStatusName}</p>
                                            </div>
                                        </React.Fragment>
                                    )}

                                </div>

                            </ListItem>
                            <Divider variant="middle" component="li" />
                        </React.Fragment>

                    )}

                </List>

            </React.Fragment >
        );
    }
}

UserList.propTypes = {
    classes: PropTypes.object.isRequired,
    talkName: PropTypes.string.isRequired
};

export default withStyles(styles)(UserList);